
import { SiteCatchment } from "@/types";

export const filterCatchmentByCategory = (catchment: SiteCatchment[], categories: string[]) => {
  return catchment.filter(c => categories.includes(c.category));
}

export const filterCatchmentByDayType = (catchment: SiteCatchment[], dayType: string) => {
  return catchment.filter(x => x.day_type === dayType);
}

export const filterCatchment = (catchment: SiteCatchment[], categories: string[], dayType: string) => {
  return filterCatchmentByCategory(filterCatchmentByDayType(catchment, dayType), categories);
}

// ---- Site selection ----
// A site audience stores its selected site ids. [0] means every site.

export const ALL_SITES = [0];

export const isAllSites = (siteIds: number[]) => siteIds.length === 1 && siteIds[0] === 0;

/** Adds the site if it isn't selected, otherwise removes it. Selecting one site replaces "all sites". */
export const toggleSite = (siteIds: number[], siteId: number) => {
  const current = isAllSites(siteIds) ? [] : siteIds;
  return current.includes(siteId)
    ? current.filter((id) => id !== siteId)
    : [...current, siteId];
};

/** Adds or removes a set of sites, e.g. a region. Replaces "all sites". */
export const changeSites = (siteIds: number[], changed: number[], remove: boolean) => {
  const selected = new Set(isAllSites(siteIds) ? [] : siteIds);
  changed.forEach((id) => remove ? selected.delete(id) : selected.add(id));
  return Array.from(selected);
};

/** Adds the item if it's missing, otherwise removes it */
export const toggleItem = <T,>(items: T[], item: T) =>
  items.includes(item) ? items.filter((i) => i !== item) : [...items, item];
